export enum ConsentEnum {
    ECONSENTANDSOFTINQUIRY = 'eConsentAndSoftInquiry',
    ECONSENT = 'eConsent',
    PromotionCode = 'PromotionCode',
    CID = 'CID',
    ReducedWorkHours = 'ReducedWorkHours',
    PaymentMethod = 'PaymentMethod',
    ReducedWorkHoursFullPay = 'ReducedWorkHoursFullPay',
    LoweredPayExplanation = 'LoweredPayExplanation',
    ReducedHoursReturn = 'ReducedHoursReturn',
    ReturnToWork = 'ReturnToWork',
    NotListedApplicantAdditionalIncome = 'NotListedApplicantAdditionalIncome',
    NotListedAdditionalIncomeDetails = 'NotListedAdditionalIncomeDetails',
    Marketing = 'Marketing',
    ReferralMethod = 'ReferralMethod',
    SoftInQuiry = 'SoftInQuiry',
    eConsentAndSoftInquiry = 'eConsent And SoftInquiry',
    eConsent = 'eConsent',
    HardInquiry = 'HardInquiry',
    ACHREPAYMENT = 'ACHREPAYMENT',
    EmailSubscribe = 'EmailSubscribe',
    SMSSubscribe = 'SMSSubscribe',
    BUSINESS = 'BUSINESS',
    DepositElectronicComm = 'DepositElectronicComm',
    DepositFinalConsent = 'DepositFinalConsent',
    BiometricConsent = 'BiometricConsent',
    VISA_DEBIT_CARD = 'VISA_DEBIT_CARD',
    COURTESY_PAY = 'COURTESY_PAY',
    V_PAY_CARD = 'V_PAY_CARD',
    ShareTransferOverDraftProtection = 'ShareTransferOverDraftProtection',
    eStatement = 'eStatement',
    eSign = 'eSign',
    DebtProtection = 'DebtProtection',
    GapProtection = 'GapProtection',
    TWInsurance = 'TWInsurance',
    MechanicalRepair = 'MechanicalRepair',
    CreditProtection = 'CreditProtection',
    JointConsent = 'JointConsent',
    FinalSubmitConsent = 'FinalSubmitConsent',
    BalanceTransferAmount = 'BalanceTransferAmount',
    BalanceTransfer = 'BalanceTransfer',
    MemberShipAccount = 'MemberShipAccount',
    CERTIFICATE_OPTION_ROLLOVER_NEW_RATE = 'CERTIFICATE_OPTION_ROLLOVER_NEW_RATE',
    CERTIFICATE_OPTION_TRANSFER_TO_SAVING_ACCOUNT = 'CERTIFICATE_OPTION_TRANSFER_TO_SAVING_ACCOUNT',
    DIVIDENDS_OPTION_CERTIFICATE = 'DIVIDENDS_OPTION_CERTIFICATE',
    DIVIDENDS_OPTION_SHARE_SAVING_ACCOUNT = 'DIVIDENDS_OPTION_SHARE_SAVING_ACCOUNT',
    DIVIDENDS_OPTION_SHARE_DRAFT_ACCOUNT = 'DIVIDENDS_OPTION_SHARE_DRAFT_ACCOUNT',
    BLANK = '',
    DIVIDENDS_OPTION = 'DIVIDENDS_OPTION',
    PHONEPIN = 'PHONEPIN',
    DEBIT_CARD = 'DEBIT_CARD',
    Overdraft_Protection = 'Overdraft_Protection',
    AutoDPPA = 'AutoDPPA'
}

export enum ConsentLocationEnum {
    DEPOSITS_ADD_INCOME = 'DEPOSITS_ADD_INCOME',
}

export enum FlowList {
    Flow1 = '1',
    Flow2 = '2'
}

export enum RadioTemplate {
    RadioCard = 'radio-card',
    RadioList = 'radio-list',
    RadioListTable = 'radio-list-table',
}

export enum Event {
    Success = 'Success',
    Error = 'Error',
    Warning = 'Warning'
}

export enum Eligibility {
    EXISTING_MEMBER = 'EXISTING_MEMBER',
    FAMILY_MEMBER = 'FAMILY_MEMBER',
    AFFILIATED_ORGANIZATION = 'AFFILIATED_ORGANIZATION',
    NONE = 'NONE',
    MILITARY = 'MILITARY',
    MILITARY_FAMILY = 'MILITARY_FAMILY',
    LIVING_AREA = 'LIVING_AREA',
    WORSHIP_AREA = 'WORSHIP_AREA',
    LEARN_AREA = 'LEARN_AREA',
    WORK_AREA = 'WORK_AREA',
    EXISTING_EMPLOYEE = 'EXISTING_EMPLOYEE'
}

export enum SearchSystem {
    Prove = 'prove',
    Core = 'core'
}
